import { render } from "./TopUp.vue?vue&type=template&id=4e577f81&scoped=true&ts=true"
import script from "./TopUp.vue?vue&type=script&lang=ts"
export * from "./TopUp.vue?vue&type=script&lang=ts"

import "./TopUp.vue?vue&type=style&index=0&id=4e577f81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e577f81"]])

export default __exports__